import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import Head from "next/head";

import {
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ArrowForwardIos } from "@mui/icons-material";

import { RequestNextApi } from "../../../api/Request";
import { ProgressContext } from "../../../components/Context/progressContext";
import MarketingNavigation from "../../../navigation/marketing";
import { ShowNotification } from "../../../utils/notification/snackbarUtils";

import IframeCard from "../../../components/Resources/IframeCard";
import { resourceNavigation } from "../../../navigation/resources";
import PageFooter from "../../../components/ArticleBlocks/PageFooter";

export default function ResourceDetail() {
  const { update: updateProgress } = useContext(ProgressContext);
  const [relatedResources, setRelatedResources] = useState([]);
  const [resource, setResource] = useState();
  const router = useRouter();
  const { pid, id } = router.query;

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await RequestNextApi.post(
          "/resources/public-resource-fetch",
          {
            slug: pid,
            id: id,
          }
        );
        if (res.data && res.data.success) {
          setResource(res.data.entry);
          setRelatedResources([
            ...res.data.entry.relatedResources,
            ...res.data.entry.resourcesInThisGroup,
          ]);
        } else {
          ShowNotification.error("Fetch page failed");
        }
      } catch (error) {
        ShowNotification.error("Fetch page failed");
      }
    };

    const initPage = async () => {
      if (pid) {
        updateProgress({ isLoading: true });
        await fetchPage();
        updateProgress({ isLoading: false });
      }
    };

    initPage();
  }, [pid]);

  // handle Related Resources navigation
  const handleRelItemNav = (slug) => {
    router.push(`${resourceNavigation.library.href}/${slug}`);
  };

  return (
    <>
      <Head>
        <title>{resource?.title || "Kingdom Advisors"}</title>
        <meta name="description" content="Kingdom Advisors Resources" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MarketingNavigation>
        <div className="marketing-resources--detail layout">
          <div className="my-3 w-full h-full ">
            <IframeCard resource={resource} />
          </div>
          <div className="tag-wrapper flex flex-wrap my-8 gap-3">
            {resource?.tags?.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                variant="outlined"
                color="primary"
              />
            ))}
          </div>
          <div>
            <Typography
              component="div"
              className="text-secondary-500 text-xl font-bold mt-8"
            >
              Related Resources
            </Typography>

            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {relatedResources.map((relatedResource) => {
                return (
                  <ListItem
                    key={relatedResource.id}
                    secondaryAction={
                      <IconButton edge="end" aria-label="forward">
                        <ArrowForwardIos />
                      </IconButton>
                    }
                    disablePadding
                  >
                    <ListItemButton
                      role={undefined}
                      onClick={() => handleRelItemNav(relatedResource.slug)}
                      dense
                    >
                      <ListItemText
                        primary={
                          <div className="text-xl">{relatedResource.title}</div>
                        }
                        className="text-xl"
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </div>
        </div>
        <PageFooter />
      </MarketingNavigation>
    </>
  );
}

ResourceDetail.getLayout = (page) => <>{page}</>;
ResourceDetail.isPublic = true;
